import React from 'react'
import { NavLink } from 'react-router-dom'

import { routes } from 'constants/routes'

import Navbar from 'components/Navbar'
import Segment from 'components/Segment'

import { ContentWrapper } from './WorkspaceSettingsLayout.styles'
import { WorkspaceMinimalFragment } from 'gqlTypes'

import WorkspaceSidebarLayout from '../WorkspaceSidebarLayout'

interface WorkspaceSettingsLayoutProps {
  workspace: WorkspaceMinimalFragment
  workspaces: WorkspaceMinimalFragment[]
  canUseSso?: boolean
}

const WorkspaceSettingsLayout = React.forwardRef<
  HTMLElement,
  React.PropsWithChildren<WorkspaceSettingsLayoutProps>
>(function WorkspaceSettingsLayout(props, ref) {
  const { workspace, canUseSso, children, workspaces } = props

  const { name, userRole } = workspace

  const workspaceId = workspace.identifier
  const userCanAdminister = userRole === 'ADMIN'
  const isFinanceRole = userRole === 'FINANCE'
  const isPersonalWorkspace = workspace.type === 'PERSONAL'

  const title = name && `${name} Workspace Settings`

  return (
    <WorkspaceSidebarLayout
      title={title}
      navbar={
        <Navbar.Section ml={2}>
          <Segment
            type="text"
            label="General"
            render={(className, children) => (
              <NavLink
                className={className}
                to={routes.WORKSPACE_SETTINGS_GENERAL.create({
                  workspaceId,
                })}>
                {children}
              </NavLink>
            )}
          />
          {!isPersonalWorkspace && (userCanAdminister || isFinanceRole) && (
            <Segment
              type="text"
              label="Billing"
              render={(className, children) => (
                <NavLink
                  className={className}
                  to={routes.WORKSPACE_SETTINGS_BILLING.create({
                    workspaceId,
                  })}>
                  {children}
                </NavLink>
              )}
            />
          )}
          {userCanAdminister && canUseSso && (
            <Segment
              type="text"
              label="Single Sign-On"
              render={(className, children) => (
                <NavLink
                  className={className}
                  to={routes.WORKSPACE_SETTINGS_SSO.create({
                    workspaceId,
                  })}>
                  {children}
                </NavLink>
              )}
            />
          )}
        </Navbar.Section>
      }
      currentWorkspace={workspace}
      workspaces={workspaces}>
      <ContentWrapper>{children}</ContentWrapper>
    </WorkspaceSidebarLayout>
  )
})

export default WorkspaceSettingsLayout
